import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.712 20.69-7.645-7.978c-.224-.268-.317-.518-.317-.731s.093-.5.28-.693l7.644-7.979a1 1 0 0 1 1.416-.03.997.997 0 0 1 .03 1.416l-6.98 7.286 7.014 7.324a.997.997 0 0 1-.03 1.415.995.995 0 0 1-1.412-.03"
    }, null, -1)
  ]))]))
}
export default { render: render }